import { useQuery } from 'react-query';

const savedProductIdListQueryKeys = {
  savedProduct: {
    detail: (productId: string) => ['savedProductDetail', productId],
    list: (list: string[]) => ['savedProductList', list],
  },
  isLogin: ['savedProductIdList', 'isLogin'],
};

export function useLoginQuery() {
  return useQuery<boolean>(savedProductIdListQueryKeys.isLogin, () => {
    const uuid = typeof localStorage !== 'undefined' ? localStorage.getItem('uuid') : null;
    return Boolean(uuid);
  });
}
